<div class="mentors-dashboard">
    <div class="header-section">
        <div class="header">
            Mentors
        </div>
        <div class="search">
            <input
                type="text"
                placeholder="Search For Trainings, Mentor Name, Employee ID, Mentee Name..."
                [(ngModel)]="searchQuery"
                (keyup.enter)="searchMentors()"
                (keyup)="updateSearchQuery($event)"
            />
            <span
                style="transform: translate(-65px, 11px);"
                class="material-symbols-outlined"
                (click)="clearSearch()"
                *ngIf="searchQuery"
            >
                close
            </span>
            <span
                class="material-symbols-outlined search-icon"
                (click)="searchMentors()"
            > search </span>
        </div>
        <div class="export">
            <button (click)="exportTrainingData()">
                <i class="iconplus mr-1">
                  <span class="material-symbols-outlined"> download </span>
                </i>
                <span class="btn-create"> Export</span>
            </button>
        </div>
    </div>
    <div class="table-container">
        <mat-table [dataSource]="mentorsList" class="fixed-table">
            <ng-container matColumnDef="employeeId">
                <mat-header-cell *matHeaderCellDef>
                    <span class="mat-heading">Employee ID </span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <div
                        class="mat-cell truncateValue"
                        [ngbTooltip]="projectNameTooltip"
                        tooltipClass="custom_tooltip"
                        triggers="manual"
                        #tooltip="ngbTooltip"
                        (mouseleave)="tooltip.close()"
                        (mouseover)="tooltip.open()"
                    >
                        <ng-template #projectNameTooltip class="custom_tooltip">
                            {{ row.mentorEmployeeID }}
                        </ng-template>
                        {{ row.mentorEmployeeID }}
                    </div>
                </mat-cell>
            </ng-container>
    
            <ng-container matColumnDef="mentor">
                <mat-header-cell *matHeaderCellDef>
                    <span class="mat-heading">Mentor Name</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <div
                        class="mat-cell truncateValue"
                        [ngbTooltip]="mentorNameTooltip"
                        tooltipClass="custom_tooltip"
                        triggers="manual"
                        #tooltip="ngbTooltip"
                        (mouseleave)="tooltip.close()"
                        (mouseover)="tooltip.open()"
                    >
                        <ng-template #mentorNameTooltip class="custom_tooltip">
                            {{ row.mentorName }}
                        </ng-template>
                        {{ row.mentorName }}
                    </div>
                </mat-cell>
            </ng-container>
    
            <ng-container matColumnDef="mentorMail">
                <mat-header-cell *matHeaderCellDef>
                    <span class="mat-heading">Mentor Email ID</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <div
                        class="mat-cell truncateValue"
                        [ngbTooltip]="mentorEmailTooltip"
                        tooltipClass="custom_tooltip"
                        triggers="manual"
                        #tooltip="ngbTooltip"
                        (mouseleave)="tooltip.close()"
                        (mouseover)="tooltip.open()"
                    >
                        <ng-template #mentorEmailTooltip class="custom_tooltip">
                            {{ row.mentorEmail }}
                        </ng-template>
                        {{ row.mentorEmail }}
                    </div>
                </mat-cell>
            </ng-container>
    
            <ng-container matColumnDef="mentee">
                <mat-header-cell *matHeaderCellDef>
                    <span class="mat-heading">Mentee Name</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <div
                        class="mat-cell truncateValue"
                        [ngbTooltip]="menteeNameTooltip"
                        tooltipClass="custom_tooltip"
                        triggers="manual"
                        #tooltip="ngbTooltip"
                        (mouseleave)="tooltip.close()"
                        (mouseover)="tooltip.open()"
                    >
                        <ng-template #menteeNameTooltip class="custom_tooltip">
                            {{ row.menteeName }}
                        </ng-template>
                        {{ row.menteeName }}
                    </div>
                </mat-cell>
            </ng-container>
    
            <ng-container matColumnDef="timeSpent">
                <mat-header-cell *matHeaderCellDef>
                    <span class="mat-heading">Mentor Log Hours</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <div
                        class="mat-cell truncateValue"
                        [ngbTooltip]="timeSpentTooltip"
                        tooltipClass="custom_tooltip"
                        triggers="manual"
                        #tooltip="ngbTooltip"
                        (mouseleave)="tooltip.close()"
                        (mouseover)="tooltip.open()"
                    >
                        <ng-template #timeSpentTooltip class="custom_tooltip">
                            {{ row.totalTimeSpent | number:'1.2-2' }}
                        </ng-template>
                        {{ row.totalTimeSpent | number:'1.2-2' }}
                    </div>
                </mat-cell>
            </ng-container>
    
            <ng-container matColumnDef="trainings">
                <mat-header-cell *matHeaderCellDef>
                    <span class="mat-heading">Training Assigned</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <div
                        class="mat-cell truncateValue"
                        [ngbTooltip]="trainingsAssignedTooltip"
                        tooltipClass="custom_tooltip"
                        triggers="manual"
                        #tooltip="ngbTooltip"
                        (mouseleave)="tooltip.close()"
                        (mouseover)="tooltip.open()"
                    >
                        <ng-template #trainingsAssignedTooltip class="custom_tooltip">
                            {{ row.trainingsAssigned }}
                        </ng-template>
                        {{ row.trainingsAssigned }}
                    </div>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row
                [class.odd]="i % 2 == 1"
                [class.even]="i % 2 == 0"
                *matRowDef="let row; columns: displayedColumns; let i = index;"
            >
            </mat-row>
        </mat-table>
        <div
            *ngIf="!mentorsList.length && !isMentorListLoading"
            style="text-align: center; margin: 10px 0;"
        >
            No mentors assigned under this service yet.
        </div>
        <mat-paginator
            #paginator
            [length]="filteredMentorsList.length"
            [pageSize]="size"
            [pageSizeOptions]="[10, 20, 30, 40, 50, 60]"
            aria-label="Select page"
            (page)="getPaginatorData($event)"
            class="paginator"
        ></mat-paginator>
    </div>
</div>